import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, User, Calendar, MapPin, Phone, Mail } from "lucide-react";
import { api, fileUrl } from "../lib/api";
import { Empty, PageHero } from "../components/ui-parts";

export default function DistrictDetail() {
  const { name } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/districts/${encodeURIComponent(name)}`).then(r => setD(r.data)).catch(() => setD({})); }, [name]);
  if (!d) return <div className="section container-narrow" data-testid="district-loading">Loading…</div>;
  return (
    <div data-testid="district-detail-page">
      <PageHero badge={`Odisha · ${name}`} title={`${name} District`} subtitle="Volunteers, programmes and Sanskrit activities in this district." />
      <section className="section">
        <div className="container-narrow">
          <Link to="/districts" className="inline-flex items-center gap-2 text-sm text-[var(--js-primary)] mb-8" data-testid="back-to-districts"><ArrowLeft size={14} /> All districts</Link>

          {d.coordinator && (
            <div className="js-card p-6 mb-8" data-testid="coordinator-card">
              <div className="text-xs uppercase text-[var(--js-secondary)] font-semibold">District Coordinator</div>
              <div className="mt-2 flex items-center gap-4">
                {d.coordinator.photo_url ? <img src={fileUrl(d.coordinator.photo_url)} alt="" className="w-16 h-16 rounded-full object-cover border border-[var(--js-border)]" /> : <div className="w-16 h-16 rounded-full bg-[var(--js-bg)] border border-[var(--js-border)] flex items-center justify-center"><User /></div>}
                <div>
                  <div className="font-heading text-lg">{d.coordinator.full_name}</div>
                  <div className="text-sm text-[var(--js-muted)]">{d.coordinator.designation}</div>
                </div>
              </div>
            </div>
          )}

          <h3 className="font-heading text-2xl text-[var(--js-primary)] mb-4">Volunteers</h3>
          {(!d.volunteers || d.volunteers.length === 0) ? <Empty title="No volunteers yet" hint="Volunteers registered in this district will appear here after admin approval." /> :
            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 mb-10">
              {d.volunteers.map(v => (
                <div key={v.id} className="js-card p-5" data-testid={`vol-${v.id}`}>
                  <div className="flex items-center gap-3">
                    {v.photo_url ? <img src={fileUrl(v.photo_url)} alt="" className="w-12 h-12 rounded-full object-cover" /> : <div className="w-12 h-12 rounded-full bg-[var(--js-bg)] border border-[var(--js-border)] flex items-center justify-center"><User size={16} /></div>}
                    <div>
                      <div className="font-semibold">{v.full_name}</div>
                      <div className="text-xs text-[var(--js-muted)]">{v.designation}</div>
                    </div>
                  </div>
                  {v.mobile && <div className="mt-3 text-sm flex items-center gap-2 text-[var(--js-muted)]"><Phone size={13} /> {v.mobile}</div>}
                  {v.email && <div className="text-sm flex items-center gap-2 text-[var(--js-muted)]"><Mail size={13} /> {v.email}</div>}
                </div>
              ))}
            </div>
          }

          <h3 className="font-heading text-2xl text-[var(--js-primary)] mb-4">Programmes</h3>
          {(!d.programmes || d.programmes.length === 0) ? <Empty title="No programmes scheduled" /> :
            <div className="grid gap-4 md:grid-cols-2 mb-10">
              {d.programmes.map(p => (
                <div key={p.id} className="js-card p-5">
                  <div className="text-xs text-[var(--js-secondary)] font-semibold uppercase mb-1">{p.status}</div>
                  <div className="font-heading text-lg text-[var(--js-primary)]">{p.name}</div>
                  <div className="text-sm text-[var(--js-muted)] mt-2 flex items-center gap-2"><Calendar size={13} /> {p.date}</div>
                  <div className="text-sm text-[var(--js-muted)] flex items-center gap-2"><MapPin size={13} /> {p.venue || p.district}</div>
                </div>
              ))}
            </div>
          }

          <h3 className="font-heading text-2xl text-[var(--js-primary)] mb-4">Courses</h3>
          {(!d.courses || d.courses.length === 0) ? <Empty title="No courses running here yet" /> :
            <div className="grid gap-4 md:grid-cols-2">
              {d.courses.map(c => <Link to={`/courses/${c.id}`} key={c.id} className="js-card p-5"><div className="font-heading text-lg text-[var(--js-primary)]">{c.name}</div><div className="text-xs text-[var(--js-muted)] mt-1">{c.mode} · {c.level}</div></Link>)}
            </div>
          }
        </div>
      </section>
    </div>
  );
}
